import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const publicAgendaApi = createApi({
  reducerPath: "publicAgendaApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ZOOMAPP_BACKEND_BASE_URL}/agenda`,
  }),
  endpoints: (builder) => ({
    createGuestSmartAgenda: builder.mutation({
      query: (body) => ({
        url: "/smart/try",
        method: "POST",
        body,
        headers: {
          generatefromai: "true",
        },
      }),
      transformResponse: (response) => response.content,
    }),
    captureLeadEmail: builder.mutation({
      query: (body) => ({
        url: "/smart/lead",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response.content,
    }),
    // Phase 2: create a real, backend-backed demo agenda for an anonymous guest.
    // Returns { guestToken, agendaId }.
    createGuestDemo: builder.mutation({
      query: (body) => ({
        url: "/demo/create/guest",
        method: "POST",
        body: body || {},
      }),
      transformResponse: (response) => response.content,
    }),
  }),
});

export const {
  useCreateGuestSmartAgendaMutation,
  useCaptureLeadEmailMutation,
  useCreateGuestDemoMutation,
} = publicAgendaApi;

export default publicAgendaApi;
